import { render, staticRenderFns } from "./MyIcon.vue?vue&type=template&id=684b22f8&scoped=true"
import script from "./MyIcon.vue?vue&type=script&lang=js"
export * from "./MyIcon.vue?vue&type=script&lang=js"
import style0 from "./MyIcon.vue?vue&type=style&index=0&id=684b22f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684b22f8",
  null
  
)

export default component.exports